import { PARAMETERS_TYPES } from '@/constants/parametersTypes'

function prepareCustomerParameters(customerParams) {
    return customerParams.map((item) => ({
        ...item,
        value: item.customer_parameter_sources.length
            ? `[${_joinDisplayNames(item.customer_parameter_sources)}]`
            : null,
    }))
}

function _joinDisplayNames(params) {
    return params.sort((a, b) => a.priority - b.priority)
        .reduce((value, element, index) => {
            if (index) {
                value += `|${element.display_name}`
            } else {
                value = element.display_name
            }

            return value
        }, '')
}

function parseParams(params) {
    return Object.keys(params).map((filterName) => ({
        label: filterName,
        isOpen: false,
        name: params[filterName].name,
        id: params[filterName].id,
        items: _createItemsParams(params[filterName], filterName),
    }))
}

function _createItemsParams(element, paramName) {
    switch (paramName) {
    case PARAMETERS_TYPES.trafficSourceParameters:
    case PARAMETERS_TYPES.callFlow:
        return _setThreeTierParametersItems(element.params)
    default:
        return _setAnotherParameterItems(element.params)
    }
}

function _setThreeTierParametersItems(parameters) {
    return Object.keys(parameters).map((paramName) => ({
        label: paramName,
        isOpen: false,
        items: _setAnotherParameterItems(parameters[paramName]),
    }))
}

function _setAnotherParameterItems(items) {
    return items.map((item) => ({
        ...item,
        name: item.hasOwnProperty('url_param')
            ? item.url_param : item.hasOwnProperty('key')
                ? item.key : item.name,
    }))
}

export {
    prepareCustomerParameters, parseParams,
}
